import {alerts} from '@/mixins/alerts.js';
export const api = {
    data : function () {
        let env = 'prod',
            url = 'https://form-backend.mobilerocket.co.uk/api/v1/form/';
        if (window.location.protocol === 'http:') {
            env = 'dev';    // dev doesn't run over https
            url = 'https://forms.test/api/v1/form/';
        }

        return {
            api : url// api URL
        }
    },
    mixins : [alerts],
    computed : {
        authenticated () {
            return this.$root.user_type != 'none';
        },
        business_id () {
            return parseInt(this.$root.user_id);
        },
        read_only () {
            if (!this.authenticated) {
                return true;
            }
            if (this.$root.user_type == 'write') {
                return false;
            }
            if (this.$root.user_type == 'rocket') {
                return this.business_id == 0;
            }
            return true;
        }
    },
    methods : {
        getUrlVars : function () {
            let params = new URLSearchParams(window.location.search);
            let obj = {};
            for(var pair of params.entries()) {
                obj[pair[0]] = pair[1];
            }
            return obj;
        },
        getRequest : function (path, params, callback) {
            if (!params) {
                params = {};
            }
            // console.log('id is: '+localStorage.getItem('builder.user_id'));
            // this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('builder.user_id');
            // params.parse = 'php';
            this.axios.get(this.api + path, {params : params})
                .then(response => {
                    // console.log('XMLHttpRequest get response', response);
                    callback(response.data);
                })
                .catch(error => {
                    this.axiosError(error);
                });
        },
        postRequest : function (path, params, callback) {
            if (!params) {
                params = {};
            }
            // params.parse = 'php';
                this.axios.post(this.api + path, params)
                    .then(response => {
                        // console.log('XMLHttpRequest post response', response);
                        callback(response.data);
                    })
                    .catch(error => {
                        this.axiosError(error);
                    });
        },
        putRequest : function (path, params, callback) {
            if (!params) {
                params = {};
            }
            // params.parse = 'php';
            this.axios.put(this.api + path, params)
                .then(response => {
                    // console.log('XMLHttpRequest put response', response);
                    callback(response.data);
                })
                .catch(error => {
                    this.axiosError(error);
                });
        },
        deleteRequest : function (path, params, callback) {
            if (!params) {
                params = {};
            }
            // params.parse = 'php';
            this.axios.delete(this.api + path, {params : params})
                .then(response => {
                    // console.log('XMLHttpRequest delete response', response);
                    callback(response.data);
                })
                .catch(error => {
                    this.axiosError(error);
                });
        },
    }
}